import type { ReactNode } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollManager from '@/components/feature/ScrollManager';

const SiteLayout = ({ children }: { children: ReactNode }) => (
  <div className="flex min-h-screen flex-col bg-background-50">
    <Navbar />
    <main className="flex-1">{children}</main>
    <Footer />
    <ScrollManager />
  </div>
);

export default SiteLayout;